"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CollapsibleLink = _interopRequireDefault(require("./CollapsibleLink"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StateContainer = require("../utils/StateContainer");

var _underscore = _interopRequireDefault(require("underscore"));

var _DeprecationUtils = require("../../util/DeprecationUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

"use strict";

/**
 * @callback Section~onToggle
 *
 * @param {boolean} expanded
 *     Current expanded/collapsed state.
 */

/**
 * @class Section
 * @desc Simple section which expand/collapse on click. In collapsed mode only
 * title is shown. When expanded shows body content.
 *
 * @param {string} [data-id="section"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {boolean} [condensed=false]
 *     When true, this applies a more condensed stlying to the section. NOTE that in order to get the full effect of
 *     this style all of the sections must be in a common parent DOM node such as a <div>.
 * @param {boolean} [disableExpand]
 *     Optional attribute to indicate that section is unopenable.
 * @param {object} [accessories]
 *     A container where text, buttons, etc may be passed in to render on the right side of the collapsed section
 * @param {boolean} [stateless]
 *     WARNING. Default value for "stateless" will be set to false from next version.
 *     To enable the component to be externally managed. True will relinquish control to the component's owner.
 *     False or not specified will cause the component to manage state internally. WARNING. Default value will be
 *     set to false from next version.
 * @param {string|object} [title]
 *     The text to display in the the collapsed view and along the top in the expanded view (adjacent to the arrow)
 * @param {string|object} [titleValue]
 *     The text to display just to the right of the title (separated by a colon)
 * @param {object} [detailsText]
 *     Text to be displayed in the center of the component; switches between collapsed and expanded versions.
 * @param {boolean} [expanded=false]
 *     Whether or not section is expanded and showing body content.
 *     When not provided, the component will manage this value.
 * @param {boolean} [contentMargin=true]
 *     Controls whether the section's content has a left margin.
 * @param {boolean} [underlined=true]
 *     Controls whether the section has an underline.
 * @param {boolean} [arrowCircle=false]
 *     If true, draws a circle around the arrow that collapses and expands the link.
 *
 * @param {Section~onToggle} [onToggle]
 *     Callback to be triggered when visibility is toggled.
 *
 * @example
 *     <Section className="section" title="My Section">
 *           <div className="section-container">     <!-- this is body, will be expanded/collapsed -->
 *               <div className="input-menu-button">
 *                   <button className="add inline">Add</button>
 *               </div>
 *           </div>
 *     </Section>
 *
 */
var SectionStateless = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SectionStateless, _React$Component);

  var _super = _createSuper(SectionStateless);

  function SectionStateless() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, SectionStateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleToggle", function () {
      if (_this.props.disableExpand) {
        return;
      }

      _this.props.onToggle(_this.props.expanded);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_maybeRenderRightContent", function () {
      var _this$props = _this.props,
          accessories = _this$props.accessories,
          detailsText = _this$props.detailsText,
          expanded = _this$props.expanded;

      if (accessories || detailsText) {
        var acc = accessories && /*#__PURE__*/_react.default.createElement("div", {
          key: "accessories",
          "data-id": _this.props["data-id"] + "-collapsible-section-accessories",
          className: "row-accessories collapsible-section__row-accessories"
        }, _this.props.accessories);

        var collapsed = detailsText ? /*#__PURE__*/_react.default.createElement("div", {
          key: "collapsed",
          className: "collapsible-section__details-text"
        }, expanded ? detailsText.expanded : detailsText.collapsed) : /*#__PURE__*/_react.default.createElement("div", {
          key: "collapsed"
        });
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "collapsible-section__right-content"
        }, [collapsed, acc]);
      } else {
        return null;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(SectionStateless, [{
    key: "render",
    value: function render() {
      var styles = {
        condensed: this.props.condensed,
        open: this.props.expanded,
        "disable-expand": this.props.disableExpand,
        "has-title-value": this.props.titleValue,
        "collapsible-section--no-underline": !this.props.underlined
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("collapsible-section", this.props.className, styles),
        "data-id": this.props["data-id"]
      }, /*#__PURE__*/_react.default.createElement(_CollapsibleLink.default, {
        "data-id": this.props["data-id"] + "-title",
        className: (0, _classnames.default)("collapsible-section-title", {
          "collapsible-section-title--circled": this.props.arrowCircle,
          "collapsible-section-title--node": this.props.title ? typeof this.props.title !== "string" : this.props.title,
          "collapsible-section-title--full-width": !this.props.accessories && !this.props.titleValue && !this.props.detailsText
        }),
        arrowPosition: _CollapsibleLink.default.arrowPositions.LEFT,
        title: this.props.title,
        expanded: this.props.expanded,
        onToggle: this._handleToggle
      }), this._maybeRenderRightContent(), this.props.titleValue && /*#__PURE__*/_react.default.createElement("span", {
        className: "collapsible-section-title-value",
        "data-id": this.props["data-id"] + "-title-value"
      }, this.props.titleValue), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("collapsible-section-content", {
          "collapsible-section-content--no-margin": !this.props.contentMargin
        }),
        "data-id": this.props["data-id"] + "-content"
      }, this.props.expanded ? this.props.children : null));
    }
  }]);
  return SectionStateless;
}(_react.default.Component);

(0, _defineProperty2.default)(SectionStateless, "propTypes", {
  accessories: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.array]),
  className: _propTypes.default.string,
  condensed: _propTypes.default.bool,
  "data-id": _propTypes.default.string,
  disableExpand: _propTypes.default.bool,
  expanded: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  titleValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  underlined: _propTypes.default.bool,
  detailsText: _propTypes.default.shape({
    collapsed: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
    expanded: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string])
  })
});
(0, _defineProperty2.default)(SectionStateless, "defaultProps", {
  condensed: false,
  contentMargin: true,
  "data-id": "section",
  disableExpand: false,
  expanded: false,
  onToggle: _underscore.default.noop,
  underlined: true
});
var Section = (0, _StateContainer.inStateContainer)([{
  name: "expanded",
  initial: false,
  callbacks: [{
    name: "onToggle",
    transform: _StateContainer.toggleTransform
  }]
}])(SectionStateless);
Section.displayName = "Section";
Section.propTypes = {
  stateless: _DeprecationUtils.deprecatedStatelessProp
};
var _default = Section;
exports.default = _default;
module.exports = exports["default"];